import { render, staticRenderFns } from "./AwardsList.vue?vue&type=template&id=49d35e5b&scoped=true&"
import script from "./AwardsList.vue?vue&type=script&lang=js&"
export * from "./AwardsList.vue?vue&type=script&lang=js&"
import style0 from "./AwardsList.vue?vue&type=style&index=0&id=49d35e5b&lang=scss&scoped=true&"
import style1 from "./AwardsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d35e5b",
  null
  
)

export default component.exports